import {Component, OnInit, ViewChild} from '@angular/core';
import { LocalStorageService } from "ng2-webstorage";
import { MessageService } from "primeng/components/common/messageservice";
import {NgForm} from '@angular/forms';
import {log} from 'util';
import {DataAnalyticsService} from '../../../../../components/dataAnalytics/dataAnalytics.service';
import {ApprovalClassModel} from '../../../../../components/googleClassroom/googleClassroom.model';
import {AddStudentRcModel, rciModel} from '../../../../../components/dataAnalytics/dataAnalytics.model';
import {Router} from '@angular/router';
import {NoticeboardService} from '../../../../../components/noticeboard/noticeboard/noticeboard.service';
import {AppConstants} from '../../../../../app.constants';
declare var gapi: any;

@Component({
  selector: "addsubjecttoexam",
  templateUrl: "ManageDRCSettings.component.html",
  styleUrls: ["ManageDRCSettings.component.scss"],
})
export class ManageDRCSettingsComponent implements OnInit {
  @ViewChild('form') form : NgForm;
  selectedFile: File;
  selectStyle: string;
  public previwbtn: boolean = true;
  public printbtn: boolean = false;
  approvalClassModel = new ApprovalClassModel();
  addStudentRcModel = new AddStudentRcModel();
  rcimodel = new rciModel()
  // public data1: AddStudentRcModel[];
  public ReportsData: any = [];
  googleUser: any;
  studentList = [];
  courseId: any;
  selectedGrade: any;
  selectedSection: any = [];
  sectionList: any = [];
  public newSectionArray = [];
  studentData: any = [];
  studentRCData: any = [];
  sumamryTable: any = [];
  public userdetailes = [];
  confirmFlag: boolean = true;
  thresholdText: number;
  selectedGCl: any;
  gclList: any;
  selectedDate: any;
  searchFlag: boolean = false;
  studentThresholdList: any = [];
  standardId: any = [];
  nameofstd: any = [];
  nameofsec: any = [];
  yearId: any = [];
  yearname: any = [];
  nameofstudent: any = [];
  nameofsem: any = [];
  nameoftest: any = [];
  loading = "none"
  ChildTestMappingId: string;
  students: any = [];
  SemesterData: any = [];
  YearData: any = [];
  TestData: any = [];
  SchoolDetailsaddress : any =[];
  NumberOfStudents: any = [];
  studentId: any = [];
  testId: any = [];
  sectionId: any = []
  guru: any = [];
  payload: any = [];
  public isEditable : Boolean = true;
  Marks: any = [];
  MaxMarks: any = [];
  today = new Date();
  Averages: any;
  schoolName :any;

  extractedContent: any;



  subjectsList: any = [];
  selectedSubject: any;
  selectedYear: any;
  selectedSemester: any;
  selectedTest: any;

  public isSuccessful: number = 0;
  public successOrErrorMsg: string = "";

  public grade: any = [];
  public selectedgrade:  any;
  public selectedsection:  any;

  public CurrentChild: any;
  public schoolLogo1 :string;
  public imgUrl1: string;
  public adminUserFlag: boolean;
  public schoolUserFlag: boolean;
  public mappedData: any;
  public attachment;
  public Address: any;
  public City : any;
  public Pincode : any;
  public PrimaryPhonenumber : any;
  public WebsiteLink : any;
  public Email : any;
  public Logo : any;
  public RegNo :any;
  public userId :string;
  public childMapId : any = [];
  public TeacherNames : any = [];
  public EncodedLogo : any;
  public ShowLevelData: any;
  public selectedlevel: any;

  public SelectAllSubjects: boolean = false;
  public imgUrl: string;

  selectedGradeName: any;


  OverallPercentage: boolean = false;
  OverallRank: boolean = false;
  OverallMaxMarks: boolean = false;
  OverallTotalMarks: boolean = false;
  ClassTeacherComments: boolean = false;
  SectionalHeadComments: boolean = false;
  HeadmasterComments: boolean = false;



  subjectDetails: any = [
    {
      'name': 'Subject Comments'
    },
    {
      'name': 'Subject Rank'
    },
    {
      'name': 'Subject Percentage'
    },
    {
      'name': 'Subject Max Marks'
    },
    {
      'name': 'Subject Weightage'
    }
  ];


  overallDetails: any = [
    {
      'id': 1,
      'name': 'Overall Percentage'
    },
    {
      'id': 2,
      'name': 'Overall Rank'
    },
    {
      'id': 3,
      'name': 'Overall Max Marks'
    },
    {
      'id': 4,
      'name': 'Overall Total Marks'
    },
    {
      'id': 5,
      'name': 'Class Teacher Comments'
    },
    {
      'id': 6,
      'name': 'Sectional Head Comments'
    },
    {
      'id': 7,
      'name': 'Headmaster Comments'
    }
  ];




  constructor(private dataAnalyticsService: DataAnalyticsService, private router: Router, private noticeboardService: NoticeboardService, private appConstants: AppConstants, private localStorage: LocalStorageService, private messageService: MessageService) {

  }

  ngOnInit() {
    this.getLevelsName();
    this.getYearData();
    //----------------------------------
    this.adminUserFlag = this.localStorage.retrieve('IsSchoolAdminUser');
    this.schoolUserFlag = this.localStorage.retrieve('Isschooluser');
    this.schoolName = this.localStorage.retrieve('auth_school');
    this.schoolLogo1 = this.localStorage.retrieve('logo');
    this.userId = this.localStorage.retrieve('id');
    this.imgUrl = this.appConstants.fileDownloadUrl;

  }


  getSubjects(){
    this.dataAnalyticsService.getSubjects(this.selectedSection.SectionId).finally(() => { }).subscribe(
      response => {
        let res: any = response;
        console.log("getSubjects", res);
        this.subjectsList = res.subsemList[0];
        try {
          this.selectedSubject = this.subjectsList[0];
        } catch (error) {

        }
      },
      error => {
        console.log("getSubjects error", error);
        this.subjectsList = [];
      });
  }


  onSelectedSubject(subject){
    console.log("onSelectedSubject", subject);
  }


  // manage-user data
  public get_userdetailes() {
    var id = this.localStorage.retrieve('Id');
    this.noticeboardService.getUserdetailbyId(id).subscribe(response => {
      this.userdetailes = response['selectedSbAccessPermission'];
      const isAdmin = this.userdetailes.some(u => u.Rank == 1);

      let result = this.mappedData.filter(m =>
        this.userdetailes.some(u => u.standardid === m.standardId && (u.Rank == 2 || u.Rank == 3)
        ));
      const sectionsResult = this.mappedData.filter(m => (
        this.userdetailes.some(u => !result.some(r => r.standardId === u.standardid) && u.Rank == 4 && m.Sections.some(s => s.SectionId === u.sectionid))
      )).map(m => ({
        ...m,
        Sections: m.Sections.filter(s => this.userdetailes.some(u => u.sectionid === s.SectionId))
      }));
      result = result.concat(sectionsResult);
      this.newSectionArray = result;
      console.log(result, 'result');
    })
  }




  private getLevelClassSection(lid) {
    this.dataAnalyticsService.GetLevelStandardSectionMapping(lid).finally(() => { }).subscribe(
      response => {
        let mappedData: any = response;
        mappedData.forEach(standard => {
          standard['Sections'].forEach(section => {
            section['StdId'] = standard['standardId'];
            section['StdName'] = standard['standardsName'];
            section['selected'] = false;
          });
        });
        console.log("mappedData", mappedData);
        mappedData.sort((a, b) => ("" + a.standardsName).localeCompare(b.standardsName, undefined, { numeric: true }));
        if (true) {
          this.mappedData = mappedData;

        }

        try {
          this.selectedGrade = mappedData[mappedData.length - 1];
          this.selectedGradeName = this.selectedGrade.standardsName;
          this.getSectionByGrade(this.selectedGrade);
          this.selectedSection = this.selectedGrade.Sections[0];
          this.getSubjects();
        } catch (error) {
          //window.location.reload();
        }

        this.students = [];
        this.NumberOfStudents = [];
        this.SemesterData = [];
        this.TestData = [];
        this.studentRCData = [];
        try {
          this.nameofsec = this.selectedSection.sectionName;
          this.sectionId = this.selectedSection.SectionId;
        } catch (error) {

        }

        ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

        /*else {
          this.mappedData = mappedData;
          this.get_userdetailes();
        }*/
      },
      error => {
        this.mappedData = [];
        this.sectionList = [];
        this.subjectsList = [];
        this.selectedGrade = null;
        this.selectedSection = null;
        this.selectedSubject = null;
      });
  };




  getSectionByGrade(grade) {
    this.subjectsList = [];
    this.selectedSubject = null;
    this.sectionList = grade.Sections;
    this.sectionList.sort((a, b) => {
      if (a.sectionName.toLowerCase() < b.sectionName.toLowerCase()) {
        return -1;
      }
      if (a.sectionName.toLowerCase() > b.sectionName.toLowerCase()) {
        return 1;
      }
      return 0;
    });
    try {
      this.selectedSection = this.sectionList[0];
      this.getSubjects();
    } catch (error) {

    }
  }


  getGclClassesListById(section) {
    this.students = [];
    this.NumberOfStudents = [];
    this.SemesterData = [];
    this.TestData = [];
    this.studentRCData = [];
    this.nameofsec = section.sectionName;
    this.sectionId = section.SectionId;
    this.nameofstudent = [];
    //this.getStudentData(this.standardId,section.SectionId,this.yearId)
    console.log('getGclClassesListById', section);
    this.getSubjects();
  }




  getYearList(year) {
    console.log(year)
    this.yearId = year.YearId;
    this.yearname = year.AcademicYear;
    console.log(this.yearname)
    console.log(this.yearId)

  }




  ////////////----------------------------------///////////////////////////----------------////////////////////----////////////////////

  private getYearData() {
    this.dataAnalyticsService.getYear()._finally(() => { }).subscribe(
      response => {
        this.YearData = response['yearList'];
        // console.log(this.YearData);
        this.yearId = this.YearData[0].YearId;
        console.log(this.yearId);
        try {
          this.selectedYear = this.YearData[0];
        } catch (error) {

        }
      }
    )
  }

  ////////////----------------------------------///////////////////////////----------------////////////////////----////////////////////

  private getLevelsName() {
    this.dataAnalyticsService
      .getLevel()
      ._finally(() => {})
      .subscribe((response) => {
        this.ShowLevelData = response;
        try {
          this.selectedlevel =  this.ShowLevelData[0].Id;
          //this.getClassSection(this.selectedlevel["Id"]);
          this.getLevelClassSection(this.selectedlevel);

        } catch (error) {

        }
        console.log("ShowLevelData", this.ShowLevelData);
      }, (error) => {

      });
  }

  getLevelsListById(){
    console.log("fffff", this.selectedlevel);
    this.getLevelClassSection(this.selectedlevel);
  }


  changegrade() {
    console.log(this.selectedgrade)

  };
  changesection(){
    console.log(this.selectedsection)
  }


  verify(e) {
    if (e.target.checked) {
      this.SelectAllSubjects = true;
    }
    else{
     this.SelectAllSubjects = false;
    }
  }


  //
  // OverallPercentage: boolean = false;
  // OverallRank: boolean = false;
  // OverallMaxMarks: boolean = false;
  // OverallTotalMarks: boolean = false;
  // ClassTeacherComments: boolean = false;
  // SectionalHeadComments: boolean = false;
  // HeadmasterComments: boolean = false;

  overallDetailsManage(e, overallDetails) {

    if (e.target.checked) {
      if (overallDetails === 1) {
        this.OverallPercentage = true;
      }
      if (overallDetails === 2) {
        this.OverallRank = true;
      }
      if (overallDetails === 3) {
        this.OverallMaxMarks = true;
      }
      if (overallDetails === 4) {
        this.OverallTotalMarks = true;
      }
      if (overallDetails === 5) {
        this.ClassTeacherComments = true;
      }
      if (overallDetails === 6) {
        this.SectionalHeadComments = true;
      }
      if (overallDetails === 7) {
        this.HeadmasterComments = true;
      }
    }
    else{
      if (overallDetails === 1) {
        this.OverallPercentage = false;
      }
      if (overallDetails === 2) {
        this.OverallRank = false;
      }
      if (overallDetails === 3) {
        this.OverallMaxMarks = false;
      }
      if (overallDetails === 4) {
        this.OverallTotalMarks = false;
      }
      if (overallDetails === 5) {
        this.ClassTeacherComments = false;
      }
      if (overallDetails === 6) {
        this.SectionalHeadComments = false;
      }
      if (overallDetails === 7) {
        this.HeadmasterComments = false;
      }
    }






  }
}



// WEBPACK FOOTER //
// /builds/yaratechnologies/talkative-parents-portal/src/app/parent/dashboard/pages/course/ManageDRCSettings/ManageDRCSettings.component.ts